import React from 'react';

export interface BlockRendererProps {
  block: { settings: Record<string, any> };
  config: {
    anaRenk: string;
    aksanRenk: string;
    font: string;
    fontBoyutu: number;
    odemeKosullari?: string;
    gecerlilikNotu?: string;
    altBilgiNotu?: string;
  };
  offer?: any;
  offerType?: 'given' | 'received';
  companyInfo?: any;
}

const TermsBlockRenderer: React.FC<BlockRendererProps> = ({ block, config, offer }) => {
  const s = block?.settings ?? {};
  const borderStyle = s.borderStyle === 'full' || s.borderStyle === 'none' || s.borderStyle === 'left-accent' ? s.borderStyle : 'left-accent';
  const bgColor = typeof s.bgColor === 'string' && s.bgColor ? s.bgColor : '#fafafa';

  const odeme = config.odemeKosullari != null ? String(config.odemeKosullari).trim() : '';
  const gecerlilik = config.gecerlilikNotu != null ? String(config.gecerlilikNotu).trim() : '';
  const notesOverride = typeof s.text === 'string' && s.text.trim() ? s.text : null;
  const notesFromOffer = offer?.notes != null ? String(offer.notes).trim() : '';
  const notesContent = notesOverride ?? notesFromOffer;

  const base: React.CSSProperties = {
    fontFamily: `'${config.font}', Arial, sans-serif`,
    fontSize: `${Math.max(config.fontBoyutu - 1, 10)}px`,
    color: '#444',
    lineHeight: 1.55,
    padding: '12px 14px',
    backgroundColor: bgColor,
    borderRadius: '4px',
    margin: 0,
  };

  let border: React.CSSProperties = {};
  if (borderStyle === 'left-accent') {
    border = {
      borderLeft: `4px solid ${config.aksanRenk}`,
      borderTop: '1px solid #e8e8e8',
      borderRight: '1px solid #e8e8e8',
      borderBottom: '1px solid #e8e8e8',
    };
  } else if (borderStyle === 'full') {
    border = { border: `1px solid ${config.aksanRenk}` };
  } else {
    border = { border: 'none' };
  }

  const section = (title: string, body: string): React.ReactNode => {
    if (!body) return null;
    return (
      <div style={{ marginBottom: '10px' }}>
        <div style={{ fontWeight: 700, color: config.anaRenk, marginBottom: '4px', fontSize: `${config.fontBoyutu}px` }}>{title}</div>
        <div style={{ whiteSpace: 'pre-wrap' }}>{body}</div>
      </div>
    );
  };

  const hasAny = Boolean(odeme || gecerlilik || notesContent);
  if (!hasAny) {
    return null;
  }

  return (
    <div style={{ ...base, ...border }}>
      {section('Ödeme Koşulları', odeme)}
      {section('Geçerlilik', gecerlilik)}
      {notesContent ? section('Notlar', notesContent) : null}
    </div>
  );
};

export default TermsBlockRenderer;
